import SimpleSchema from 'simpl-schema';
import moment from 'moment';

import store from '../../config/configureStore';
import { groupBOffenses } from 'simpl-schema-validation/CategoryCodes/groupBOffenses';
import { getCategoryOfCode, getDataOfDictionaryOptions } from 'utils/functions';
import { displayDateTime } from 'reducers/TimeReducer';

export const arresteesSchema = () => {
  SimpleSchema.setDefaultMessages({
    messages: {
      en: store?.store.getState().incident.ibrsValidationRules?.arrestee || {},
    },
  });

  return new SimpleSchema({
    offenseDescription: {
      type: String,
      optional: true,
      custom() {
        // NIBRS-2019.2-167: Arrest Offense Code
        if (!this.value) {
          return 'NIBRS-2019.2-167';
        }

        // NIBRS-2019.2-168: Arrest Offense Code
        if (this.value === '09C') {
          return 'NIBRS-2019.2-168';
        }

        // NIBRS-2019.2-169: Arrest Offense Code
        const offenseFBICode = this.obj.currentOffense.values?.statuteDetails?.FBICode;
        const arrestOffenseFBICode = getDataOfDictionaryOptions(
          'statuteFBICodes',
          'Description',
          'FBICode',
          this.value,
          true
        );

        if (groupBOffenses.includes(offenseFBICode)) {
          if (!groupBOffenses.includes(arrestOffenseFBICode)) {
            return 'NIBRS-2019.2-169';
          }
        }
      },
    },

    arrestDate: {
      type: Date,
      label: 'NIBRS-2019.2-164: Arrest Date',
      optional: true,
      custom() {
        // NIBRS-2019.2-902: Arrest date
        if (!this.value) {
          return 'NIBRS-2019.2-902';
        }
        let incidentOccuredDate = moment(displayDateTime(this.obj.incident.values.occurred)).format(
          'YYYY-MM-DD HH:mm'
        );
        let arrestDate = moment(this.value).format('YYYY-MM-DD HH:mm');

        if (new Date(arrestDate) < new Date(incidentOccuredDate)) {
          return 'NIBRS-2019.2-164';
        }
      },
    },

    arresteeArmedWith: {
      type: String,
      label: 'NIBRS-2019.2-170: Arrestee Armed With',
      optional: true,
      custom() {
        // NIBRS-2019.2-170: Arrestee Armed With
        if (!this.value || !JSON.parse(this.value)?.length) {
          return 'NIBRS-2019.2-170';
        }

        if (!this.value) return;
        const parsedValues = JSON.parse(this.value);
        if (!parsedValues) return;

        // NIBRS-2019.2-171: Arrestee Armed With
        if (parsedValues.length > 2) {
          return 'NIBRS-2019.2-171';
        }

        // NIBRS-2019.2-173: Arrestee Armed With
        let arresteeArmedWithCodes = [];
        const codeArresteeArmed = store.store.getState().dictionary.codeArresteeArmed;
        parsedValues.forEach((value) => {
          arresteeArmedWithCodes.push(getCategoryOfCode(codeArresteeArmed, value));
        });

        if (arresteeArmedWithCodes.includes('01') && parsedValues.length > 1) {
          return 'NIBRS-2019.2-173';
        }

        // NIBRS-2019.2-172: Arrestee Armed With
        let values = [];
        parsedValues.forEach((item) => {
          if (!values.includes(item)) {
            values.push(item);
          }
        });
        if (values.length < parsedValues.length) {
          return 'NIBRS-2019.2-172';
        }
      },
    },

    arresteeSegmentsIndicator: {
      type: String,
      label: 'NIBRS-2019.2-166: Arrestee Segments',
      optional: true,
      custom() {
        if (!this.value) {
          return 'NIBRS-2019.2-166';
        }
      },
    },

    juvenileDisposition: {
      type: String,
      optional: true,
      custom() {
        // NIBRS-2019.2-177: Arrestee Age
        if (this.obj.arresteeParty.personDetail.values.age < 18) {
          if (!this.value) {
            return 'NIBRS-2019.2-177';
          }
        }
        // NIBRS-2019.2-181: Disposition of Arrestee Under 18
        if (this.obj.arresteeParty.personDetail.values.age >= 18) {
          if (this.value) {
            return 'NIBRS-2019.2-181';
          }
        }
      },
    },

    arrestType: {
      type: String,
      optional: true,
      custom() {
        // NIBRS-2019.2-165: Arrest Type
        if (!this.value) {
          return 'NIBRS-2019.2-165';
        }
      },
    },
  });
};
